import {
  addDays,
  endOfISOWeek,
  endOfMonth,
  format,
  getISOWeek,
  isBefore,
  parse,
  startOfISOWeek,
  startOfMonth,
} from 'date-fns';
import memoize from 'lodash/memoize';
import values from 'lodash/values';

import { pasqua } from '@/lib/pasqua';

const getDays = (focusDay: string) => {
  const parsedFocusDay = parse(focusDay, 'yyyy-MM-dd', new Date());
  const weeks: { [week: string]: Date[] } = {};
  let dayCursor = startOfISOWeek(startOfMonth(parsedFocusDay));
  let weekCursor = 'w' + getISOWeek(dayCursor);
  const lastDay = endOfISOWeek(endOfMonth(parsedFocusDay));

  while (isBefore(dayCursor, lastDay)) {
    if (!weeks[weekCursor]) {
      weeks[weekCursor] = [];
    }

    weeks[weekCursor]!.push(dayCursor);
    dayCursor = addDays(dayCursor, 1);
    weekCursor = 'w' + getISOWeek(dayCursor);
  }
  const result = Object.values(weeks);
  return result;
};

export const getMemoDays = memoize(getDays);

export function minutesToCommaSeparatedDaysHoursMinutes(
  dailyHours: number,
  minutes: number,
) {
  const days = Math.floor(minutes / (dailyHours * 60));
  const hours = Math.floor((minutes % (dailyHours * 60)) / 60);
  const remainingMinutes = minutes % 60;

  const dayStr =
    days === 0 ? null : days === 1 ? '1 giornata' : `${days} giornate`;
  const hourStr = hours === 0 ? null : hours === 1 ? '1 ora' : `${hours} ore`;
  const minStr =
    remainingMinutes === 0
      ? null
      : remainingMinutes === 1
        ? '1 minuto'
        : `${remainingMinutes} minuti`;

  const sections = [dayStr, hourStr, minStr].filter(Boolean);

  return sections.join(', ');
}

export const convertMinutesToHourMinuteWords = (
  minutesTotal: number,
  short?: boolean,
) => {
  const diffTime = minutesTotal * 60;
  if (!diffTime) return '0:00'; // divide by 0 protection
  const minutes = Math.abs(Math.floor(diffTime / 60) % 60);
  const hours = Math.abs(Math.floor(diffTime / 60 / 60));

  let result = '';

  if (hours) {
    result += `${hours}${short ? 'h' : hours < 2 ? ' ora' : ' ore'}`;
  }

  if (hours && minutes) {
    result += short ? '' : ' e ';
  }

  if (minutes) {
    result += `${minutes}${short ? 'm' : minutes < 2 ? ' minuto' : ' minuti'}`;
  }

  return result;
};

// export function showDayLess(day: Date, monthEntries?: MonthEntries) {
//   const dayEntry = monthEntries?.find((e) => isSameDay(e.date, day));
//   const entriesCount = dayEntry?.entries.length ?? 0;

//   return !entriesCount && (!dayEntry?.isBusinessDay || isFuture(day));
// }

export const memoHolidays = memoize(
  (year: number, holidaysResult: Record<string, string>) => {
    const array = values(holidaysResult).map(
      (monthAndDay) => `${year}-${monthAndDay}`,
    );
    const now = new Date();
    const easter = pasqua(year).toString();
    const easterMonday = format(
      addDays(parse(easter, 'yyyy-MM-dd', now), 1),
      'yyyy-MM-dd',
    );
    array.push(easter);
    array.push(easterMonday);
    return array.map((d) => parse(d, 'yyyy-MM-dd', now));
  },
);
